module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-1-mobile-65b4fccde92594583191183a51360632.png";